import overview from './overview';
import programAgentDailyPurchase from './programAgentDailyPurchase';
import programAgentDailyRebate from './programAgentDailyRebate';
import totalCustodyAsset from './totalCustodyAsset';

export default { overview, programAgentDailyPurchase, programAgentDailyRebate, totalCustodyAsset };
